export default __webpack_public_path__ + "static/media/cancer12.d1d9567b.jpg";